import { Reveal } from "./motion";

const chapters = [
  "Before there is a strategy, a song, a message, a business, or a transformation, there is a frequency beneath it. The SEAL Collective explores what happens when we begin there.",
  "Through voice, sound, consciousness, creative expression, technology, and meaningful human connection, our work is designed to help people reconnect with what is genuine, communicate from a deeper place, and create from greater coherence.",
  "This is not one offering. It is an ecosystem of work built around a central idea.",
];

const HeartOfWork = () => (
  <section
    id="heart-of-work"
    data-testid="heart-of-work-section"
    className="relative mx-auto max-w-7xl px-6 py-32 lg:px-12 lg:py-40"
  >
    <div className="pointer-events-none absolute right-0 top-24 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12)_0%,transparent_65%)]" />

    <Reveal>
      <p className="mb-6 text-[0.65rem] font-light uppercase tracking-[0.45em] text-[#8a6d1f]">The Manifesto</p>
      <h2
        data-testid="heart-of-work-headline"
        className="font-serif-display max-w-3xl text-4xl font-light tracking-tight text-[#16130e] sm:text-5xl"
      >
        THE HEART OF THE WORK
      </h2>
    </Reveal>

    <div className="mt-20 space-y-20 lg:ml-24">
      {chapters.map((text, i) => (
        <Reveal key={i} delay={i * 0.08}>
          <article data-testid={`manifesto-chapter-${i + 1}`} className="flex gap-8 lg:gap-16">
            <span className="mt-2 hidden h-px w-16 shrink-0 bg-gradient-to-r from-[#b8912e]/60 to-transparent sm:block" />
            <p className="max-w-2xl text-base font-extralight leading-loose text-black/65 md:text-lg">
              {text}
            </p>
          </article>
        </Reveal>
      ))}

      <Reveal delay={0.1}>
        <div className="border-l border-[#b8912e]/50 pl-8 lg:pl-16">
          <p
            data-testid="manifesto-keyline"
            className="font-serif-display max-w-3xl text-3xl font-light leading-snug text-gold-gradient sm:text-4xl lg:text-5xl"
          >
            WHAT MOVES THROUGH THE HEART CAN MOVE PEOPLE.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default HeartOfWork;
